// Lucide icon: file-chart-column (https://lucide.dev/icons/file-chart-column)
import { FileChartColumn } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconReport = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <FileChartColumn />
    </IconComponentStyled>
  )
}
